import ReactMarkdown from "react-markdown";
import rehypeAutolinkHeadings from "rehype-autolink-headings";
import rehypeSanitize from "rehype-sanitize";
import rehypeSlug from "rehype-slug";
import remarkGfm from "remark-gfm";

export default function Markdown({ children }) {
  const content = typeof children === "string" ? children : "";

  return (
    <div className="ia-markdown">
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[
          rehypeSanitize,
          rehypeSlug,
          [rehypeAutolinkHeadings, { behavior: "append" }],
        ]}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
}
